import React, { useState, useEffect, useMemo } from 'react';
import { Dropdown } from 'react-bootstrap'
import Label, { useLabels } from "components/general/Label"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { FilterEventTypes, createEventData, pagesWithGenderFilter, publishFilterEvent } from 'components/common/ocs-custom-events/filterEvents';

export default function SelectorGender({ page = "", gendersList, useGendersList = false, onSelectGender, selectedGender }) {
    const [textCombo, setTextCombo] = useState();
    const params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    const [genders, setGenders] = useState([]);
    const fLabel = useLabels()
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page)
    //copy parameters URL to change 
    let paramsURL = { ...params }

    const defaultGenders = [
        { code: 'TOT', label: fLabel({ data: 'LabelAllMedallists' }) },
        { code: 'M', label: fLabel({ data: 'HeaderMenDesc' }) },
        { code: 'W', label: fLabel({ data: 'HeaderWomenDesc' }) },
        { code: 'X', label: fLabel({ data: 'HeaderMixedDesc' }) },
        { code: 'O', label: fLabel({ data: 'HeaderOpenDesc' }) }
    ];

    useEffect(() => {
        let tempGendersList = [];
        if (useGendersList && Array.isArray(gendersList)) {
            tempGendersList = [defaultGenders[0], ...(defaultGenders?.filter(g => gendersList?.includes(g?.code)) || [])]
            // tempGendersList = defaultGenders
        } else {
            tempGendersList = defaultGenders;
        }
        setGenders(tempGendersList);
        const selectedGNEDER = ['medal', 'medallists'].includes(page) ? selectedGender : paramsURL["mirs_gender"]
        let lbl = tempGendersList.find(item => item.code === selectedGNEDER)?.label;
        if (!lbl) { lbl = <Label data={'LabelAllMedallists'} /> }
        setTextCombo(lbl);
    }, [paramsURL["mirs_gender"], selectedGender, useGendersList, gendersList, page]);


    const handleOnChange = (key) => {
        paramsURL["mirs_gender"] = key
        if (pagesWithGenderFilter.includes(page)) {
            const payload = createEventData(FilterEventTypes.GENDER, key);
            publishFilterEvent(payload);
        }
        if (['medal', 'medallists'].includes(page)) {
            onSelectGender(key);
        } else {
            setParamsUrl(paramsURL);
            setShouldNavigate(true);
        }
    };

    return (

        <Dropdown onSelect={handleOnChange} id="selectorGender" className={"selectorContainer "} >
            <Dropdown.Toggle variant="success" id="dropdown-basic">
                {textCombo}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {genders?.map((g) => (
                    <Dropdown.Item key={`Selector-Gender-${g.code}`} eventKey={g?.code} >
                        <div className="itemMedal justify-content-left">
                            {g.label}
                        </div>
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};


